export const getVersion = () => typeof window !== 'undefined' ? document?.querySelector('meta[name="version-info"]')?.getAttribute('content') : 'no-version';
